import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { RouteProps } from 'react-router-dom';

import messages from '../messages';
import classNames from 'classnames';

interface IWelcome {}

const Welcome: React.SFC<RouteProps & IWelcome> = ({}) => {
  return (
    <div className={classNames('c-bubble__content')}>
      <div className="c-bubble__content-text">
        <FormattedMessage {...messages.welcome} />
      </div>
    </div>
  );
};

export default Welcome;



// WEBPACK FOOTER //
// ./src/containers/start/components/Welcome.tsx